/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { PipelinesEnvEnum } from 'src/components/pipelines/utils/env-base-url';

const IndicatorRibbon = styled.div<{ background: string }>(props => ({
  boxSizing: 'border-box',
  background: props.background,
  bottom: '16px',

  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
  color: colors.N0,

  font: token('font.body'),
  fontWeight: token('font.weight.bold'),
  paddingBlock: token('space.050'),
  height: '28px',
  left: '-30px',
  position: 'fixed',
  textAlign: 'center',
  transform: 'rotate(45deg)',
  userSelect: 'none',
  width: '120px',
  zIndex: 99999,
}));

export type Props = {
  env: string;
};

function getBackground(env: string) {
  // The colors comes from launch darkly
  switch (env) {
    case PipelinesEnvEnum.DDEV:
      return 'rgb(51, 102, 153)';
    case PipelinesEnvEnum.STAGING:
      return 'rgb(255, 89, 0)';
    default:
      return colors.N100;
  }
}

const PipelinesEnvIndicator = ({ env }: Props) => {
  const background = getBackground(env);
  return (
    <IndicatorRibbon
      background={background}
      title={`Current pipelines environment: ${env.toUpperCase()}`}
    >
      {env.toUpperCase()}
    </IndicatorRibbon>
  );
};

export default PipelinesEnvIndicator;
